import charterSchemaJson from './charter.frontmatter.v1.json' with { type: 'json' };
import toolsSchemaJson from './tools.frontmatter.v1.json' with { type: 'json' };
import integrationMetadataSchemaJson from './integration-metadata.v1.json' with { type: 'json' };

export const charterSchema = charterSchemaJson;
export const toolsSchema = toolsSchemaJson;
export const integrationMetadataSchema = integrationMetadataSchemaJson;
